import React from 'react'
import styles from './index.module.scss'

type svgType = {
  width?: string
  height?: string
  name: string
  color?: string
  className?: string
}

const SvgIcon = React.memo(
  ({
    width = '20',
    height = '20',
    name,
    // color = '#ffffff',
    color,
    className
  }: svgType) => {
    return (
      <svg
        className={className || styles.iconsvg}
        aria-hidden="true"
        width={width}
        height={height}
      >
        <use xlinkHref={'#' + name} fill={color}></use>
      </svg>
    )
  }
)

export default SvgIcon
